import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ViewSDKClient } from './view-sdk.service';

export interface PreviewOptions {
  fileUrl?: string;
  path: string; //path of uploadUrl
  pages: number; //number of documentPages,
  previewPages?: number;
  watermark?: boolean;
  printSettings?: any;
}

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  firebaseConfig = environment.firebaseConfig;

  constructor(
    @Inject('FIREBASE_REGION') private region: string,
    private httpClient: HttpClient,
    private viewSDKClient: ViewSDKClient
  ) {
  }

  getPreview(options: PreviewOptions) {
    const { path, pages, printSettings, watermark } = options;
    const previewFunctionUrl = `https://${this.region}-${this.firebaseConfig.projectId}.cloudfunctions.net/getPreview`;
    // const base = 'https://europe-west1-copias-a-domicilio-develop.cloudfunctions.net/getPreview';

    const url = options.fileUrl ?? `${previewFunctionUrl}`;
    const headers = {};
    const previewOptions = {
      isPdf: !!options.fileUrl,
      documentPages: pages,
      documentPath: path ?? null,
      previewPages: options.previewPages ?? 4,
      watermark: watermark ?? true,
      printSettings: printSettings
    };

    console.log("previewPdf", {
      url,
      options: previewOptions
    });
    this.previewPdf({
      url,
      options: previewOptions
    });
  }

  previewPdf(fileData) {
    this.viewSDKClient.ready().then(() => {
      /* Invoke file preview */
      this.viewSDKClient.previewFile('', {
        /* Pass the embed mode option here */
        embedMode: 'LIGHT_BOX',
        showDownloadPDF: false,
        showPrintPDF: false
      }, fileData);
    });
  }

  getColorName(color: string): string {
    if (color === 'Cian') {
      return 'Celeste';
    } else {
      return color;
    }
  }
}
